import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE = new InjectionToken<Storage>(
  'LocalStorageToken',
  typeof localStorage !== 'undefined' ? { providedIn: 'root', factory: () => localStorage } : undefined
);